import React from 'react';
import { ResponsivePie } from '@nivo/pie'
import { isNull, max } from 'lodash';

import { ColorPalette } from 'types/constants';

import style from '../style.module.scss';

interface Props {
  chartProps?: any;
  colorPalette: ColorPalette;
  data: {
    percentage?: boolean;
    range?: {
      high: number;
      low: number;
    };
    value: number | null;
  };
  interior?:  string | React.ReactNode | ((data: any) => React.ReactNode);
  size: number;
}

const SimpleDonutChart: React.FC<Props> = (props) => {
  // Always show at least a sliver of progress so that it is obvious that this is a donut chart
  const maximum = (props.data.range?.high || 100);
  const value = max([props.data.value, maximum / 100]);

  const data = [
    {
      id: 'shaded',
      label: 'shaded',
      value: value,
      color: props.colorPalette.dark
    },
    {
      id: 'unshaded',
      label: 'unshaded',
      value: maximum - value,
      color: props.colorPalette.light
    }
  ];

  return (
    <div className={style.chart} style={{ height: props.size, position: 'relative', width: props.size }}>
      <ResponsivePie
        data={data}
        enableArcLabels={false}
        enableArcLinkLabels={false}
        fit
        innerRadius={0.7}
        isInteractive={false}
        colors={[props.colorPalette.dark, props.colorPalette.light]}
        {...props.chartProps}
      />

      <div
        className="align-items-center d-flex flex-1 justify-content-center"
        style={{
          height: props.size,
          left: 0,
          position: 'absolute',
          top: 0,
          width: props.size
        }}
      >
        {
          props.interior ? (
            (() => {
              if (typeof props.interior === 'function') {
                return props.interior(props.data.value);
              } else if (typeof props.interior === 'string') {
                return <span dangerouslySetInnerHTML={{ __html: props.interior }} />;
              } else {
                return props.interior;
              }
            })()
          ) : (
            <strong>
              {
                isNull(props.data.value) ? (
                  <span style={{ color: props.colorPalette.dark, fontSize: props.size * 0.2 }}>-</span>
                ) : (
                  <>
                    <span style={{ color: props.colorPalette.dark, fontSize: props.size * 0.25 }}>{props.data.value}</span>
                    {
                      props.data.percentage && (
                        <span style={{ color: props.colorPalette.dark, fontSize: props.size * 0.15 }}>%</span>
                      )
                    }
                  </>
                )
              }
            </strong>
          )
        }
      </div>
    </div>
  );
};

export default SimpleDonutChart;
